'use strict';

import $ from 'jquery';
import 'simplebar';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';

// import entryModal from './project/entry-modal';
import search from './project/search';
import select from './project/select';
import formValidation from './project/form-validation';
import inquireForm from './project/inquire-form';
import meetingForm from './project/meeting-form';
import globalInquireForm from './project/global-inquire-form';
import tabs from './project/tabs';
import contentMenu from './project/content-menu';
import modal from './project/modal';
import events from './project/events';
import Filter from './project/filter.class';
import docViewer from './project/doc-viewer';
import publications from './project/publications';
import feedback from './project/feedback';
import filterTree from './project/filter-tree';
import medEdFilter from './project/med-ed-filter';
import { URL_PARAMS, LOCATION_HASH } from './utils/constants';
import './project/chat';
import maintenanceModal from './project/maintenance-modal';
import len4prep from './project/len4prep';
import accordion from './project/accordion';
import imagePopup from './project/image-popup';
import recaptcha from './project/recaptcha';
import allergenChecker from './project/allergen-checker';

$(function () {
  setTimeout(() => {
    $('html').removeClass('page-loading');
  }, 100);

  // Project functions
  // entryModal();
  maintenanceModal();
  search();
  select();
  formValidation();
  inquireForm();
  meetingForm();
  globalInquireForm();
  tabs();
  contentMenu();
  modal();
  events();
  docViewer();
  feedback();
  publications();
  filterTree();
  new Filter();
  accordion();
  imagePopup();
  recaptcha();

  if ( $('.js-allergen-checker').length ) {
    allergenChecker();
  }

  // Prevent adding '#' to the URL
  $('a[href="#"]').on('click', function (e) {
    e.preventDefault();
  });

  // Tooltip
  $('.js-tooltip-btn').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $(this).closest('.js-tooltip').find('.js-tooltip-panel').toggleClass('is-active');
  });

  // Toggle active class
  $('.js-toggle-btn').on('click', function (e) {
    e.preventDefault();

    const dataTarget = $(this).data('target');

    $(this).toggleClass('is-active');
    $(`.js-toggle-target[data-target="${dataTarget}"]`).toggleClass('is-active');
  });

  // Smooth scroll to anchor
  $('.js-anchor-link').on('click', function (e) {
    e.preventDefault();

    const href = $(this).attr('href');

    $('html, body').animate({
      scrollTop: href === '#top' ?
        0 :
        $(href).offset().top - $('.js-header').height()
    }, 500);
  });

  // Go back
  $('.js-go-back-link').on('click', function (e) {
    e.preventDefault();

    history.back();
  });

  // To top button
  $(window).on('scroll', function () {
    const btn = $('.js-to-top-btn');

    if ( $(this).scrollTop() > $('.js-header').height() + 100 ) {
      btn.addClass('is-visible');
    } else {
      btn.removeClass('is-visible');
    }
  });

  // Pre-select product if it is set in the URL params
  // on the "meet form direct" page
  if ( $('.meet-form-direct-index').length ) {
    const productParam = URL_PARAMS.get('product');

    if ( productParam ) {
      const option = $(`.main-content select[name="Product"] option[value="${productParam.toUpperCase()}"]`);

      if ( option.length ) {
        option.prop('selected', true);
        $('.main-content select[name="Product"]').trigger('change');
      }
    }
  }

  // Med ed page
  if ( $('.page-med-ed').length ) {
    medEdFilter();
  }

  // Len4Prep functions
  if ( $('.page-len4prep').length ) {
    len4prep();
  }
});

window.onload = () => {
  document.body.classList.remove('preload');

  // Ignore /len4prep pages
  if ( $('.page-len4prep').length ) return;

  // Smooth scroll to anchor on page load
  if ( LOCATION_HASH ) {
    let locationHashId = LOCATION_HASH.replace('#', '');
    locationHashId = locationHashId.split('?')[0];

    let $target = null;

    if ( $(`#${locationHashId}`).length ) {
      $target = $(`#${locationHashId}`);
    } else if ( $(`[name="${locationHashId}"]`).length ) {
      $target = $(`[name="${locationHashId}"]`);
    }

    if ( $target ) {
      $('html, body').animate({
        scrollTop: $target.offset().top - $('.js-header').height()
      }, 500);
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/main.js